module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/water/water.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/water/water.component.css
// module chunks = main